const Device = {
  // Resolution
  Width: window.innerWidth,
  Height: window.innerHeight,

  // SafeArea
  SafeAreaInset: {
    Top: 0,
    Bottom: 0,
    Left: 0,
    Right: 0,
  },
} as const;

export const getScreenWidth = () => {
  // return Math.min(Math.max(300, WIDTH), 600);
  return Math.min(Math.max(Device.Width, 360), 600);
};
